import React from "react";
import { Card, CardContent, Typography, Box } from "@mui/material";
import { alpha } from "@mui/material/styles";
import {
  RemoveRounded,
  TrendingDownRounded,
  TrendingUpRounded,
} from "@mui/icons-material";

function StatBox({
  title,
  stat,
  description,
  footer,
  footerColor,
  cardVariant = "shadow",
  textVariant = "h4",
  cardProps = {},
  noDataMessage,
}) {
  const isFooterText = typeof footer === "string" || typeof footer === "number";
  const footerTone = footerColor || "text.secondary";
  const FooterIcon =
    footerTone === "success.main"
      ? TrendingUpRounded
      : footerTone === "error.main"
        ? TrendingDownRounded
        : RemoveRounded;

  return (
    <Card
      variant={cardVariant}
      {...cardProps}
      data-testid={"statbox"}
      sx={{
        height: "100%",
        minHeight: 150,
        position: "relative",
        overflow: "hidden",
        ...cardProps.sx,
      }}
    >
      <CardContent>
        <Typography
          variant="overline"
          color="text.secondary"
          sx={{ fontWeight: 700, letterSpacing: "0.08em" }}
          gutterBottom
        >
          {title}
        </Typography>
        {noDataMessage ? (
          <Typography>{noDataMessage}</Typography>
        ) : (
          <React.Fragment>
            <Typography
              variant={textVariant}
              fontWeight="bold"
              color="secondary.main"
              sx={{ mb: 0.5, letterSpacing: "-0.03em" }}
            >
              {stat}
            </Typography>

            {description && (
              <Typography variant="body2" color="text.secondary">
                {description}
              </Typography>
            )}

            {footer ? (
              <Box
                mt={0.5}
                sx={{ height: 20, display: "flex", alignItems: "center" }}
              >
                {isFooterText ? (
                  <Box
                    sx={(theme) => {
                      const [paletteKey, shade = "main"] =
                        footerTone.split(".");
                      const tone =
                        theme.palette[paletteKey]?.[shade] ||
                        theme.palette.text.secondary;
                      return {
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 0.5,
                        px: 1,
                        py: 0.4,
                        color: tone,
                        backgroundColor: alpha(tone, 0.1),
                        borderRadius: 999,
                      };
                    }}
                  >
                    <FooterIcon sx={{ fontSize: 15 }} />
                    <Typography
                      variant="caption"
                      color="inherit"
                      fontWeight={600}
                    >
                      {footer}
                    </Typography>
                  </Box>
                ) : (
                  <Box width="100%">{footer}</Box>
                )}
              </Box>
            ) : (
              <Box
                mt={0.5}
                sx={{ height: 20, display: "flex", alignItems: "center" }}
              />
            )}
          </React.Fragment>
        )}
      </CardContent>
    </Card>
  );
}

export default StatBox;
